/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuesday_May_1210Inputs */

const en__field_enum_tuesday_may_1210 = /** @type {(inputs: _Field_Enum_Tuesday_May_1210Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuesday, May 12, 2026`)
};

const de__field_enum_tuesday_may_1210 = /** @type {(inputs: _Field_Enum_Tuesday_May_1210Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dienstag, 12.05.2026`)
};

/**
* | output |
* | --- |
* | "Tuesday, May 12, 2026" |
*
* @param {_Field_Enum_Tuesday_May_1210Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuesday_may_1210 = /** @type {((inputs?: _Field_Enum_Tuesday_May_1210Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuesday_May_1210Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuesday_may_1210(inputs)
	return de__field_enum_tuesday_may_1210(inputs)
});
export { _field_enum_tuesday_may_1210 as "_field_enum_TUESDAY_MAY_12" }